
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper}   from './user.log.entry.helper';

/**
 *
 * @class AddLineupBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class AddLineupBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^add-lineup-(.*)/i)[1];

    let category: string   = '';

    if (/main/.test(data.ct)) {

      category = 'MAIN';

    } else if (/proposed/.test(data.ct)) {

      category = 'PROPOSED';

    } else if (/siding/.test(data.ct)) {

      category = 'SIDING';
    }

    const depDir:   string = data.dd;

    let before: any    = null;
    let after: any     = null;

    if (data.tk.a != null) {

      after = {
        name:    data.tk.a.d,
        mileage: data.tk.a.m
      };
    }

    if (data.tk.b != null) {

      before = {
        name:    data.tk.b.d,
        mileage: data.tk.b.m
      };
    }

    const track: any = {
      id:      data.tk.i,
      track:   data.tk.t,
      mileage: data.tk.m,
      before,
      after
    };

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Add Trains [ ${category} ] ${depDir} | ${track.track}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'add-lineup',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      deploymentDir:   depDir,
      category,
      track,
      u
    };

  }
}
